import { HttpServiceResponse } from '../../shared'
import { UploadFileParams } from '../models/uploadFile-prams.model'
import AbstractAccountProvider from './linkedFiles-abstract.provider'

export class UploadFilesProvider extends AbstractAccountProvider {
  urlPath = 'linkedfiles_upload_file_api'

  public upload<T>(params: UploadFileParams): Promise<HttpServiceResponse<T>> {
    const data = new FormData()

    if (params) {
      Object.entries(params)
        .filter(([, value]) => value)
        .forEach(([key, value]) => {
          data.append(key, value)
        })
    }

    return this.http.post(this.url, data)
  }
}
